module.exports = __webpack_public_path__ + "img/ws_ultraplatinum.77d15b7b.png";